import Vue from 'vue'
import Vuex from 'vuex'

import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import state from './state'

import creditcardslips from './modules/creditcardslips'
import authentication from './modules/authentication'
import crediteuren from './modules/crediteuren'
import debiteuren from './modules/debiteuren'
import invoices from './modules/invoices'
import settings from './modules/settings'
import receipts from './modules/receipts'
import user from './modules/user'

Vue.use(Vuex)

export default new Vuex.Store({
  actions,
  getters,
  mutations,
  state,
  modules: {
    creditcardslips,
    authentication,
    crediteuren,
    debiteuren,
    invoices,
    settings,
    receipts,
    user
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js